
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/next/seminars/1",
      function () {
        return require("private-next-pages/next/seminars/1.tsx");
      }
    ]);
  